﻿import * as React from "react";
import { IBaseSectionProps } from "./Sections/IBaseSectionProps";
import { IMenuSectionProps } from "./Sections/MenuSection";

export interface ISectionHeaderProps {
    sectionProps: IMenuSectionProps;
    searchFunction: (newSearchQuery: string) => void;
}

export const SectionHeader: React.FunctionComponent<ISectionHeaderProps> = (
    props,
): React.ReactElement => {
    const searchTools = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value: string = event.target.value;

        props.searchFunction(value);
    };

    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.
    const activeSectionsComparer = (
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] => {
        for (let i = 0; i < activeSections.length; i++) {
            if (
                activeSections[i].sectionType === props.sectionProps.sectionType
            ) {
                activeSections.splice(i, 1);
                i--;
            }
        }
        return activeSections;
    };

    const closeSectionOnClick = (): void => {
        props.sectionProps.toggleSection(
            props.sectionProps,
            activeSectionsComparer,
        );
    };

    return (
        <div className={`section-sectionheader`}>
            <div className={`sectionheader-titlecontainer`}>
                <img
                    alt={props.sectionProps.name}
                    className={`titlecontainer-icon`}
                    src={`/Images/Icon?icon=${props.sectionProps.moduleID}&folder=Module`}
                />
                <div className={`titlecontainer-title`}>
                    {props.sectionProps.name}
                </div>
                <div
                    className={`titlecontainer-backbutton`}
                    onClick={closeSectionOnClick}
                >
                    <img
                        alt={`&lt;`}
                        className={`backbutton-icon`}
                        src={`/Images/BackIcon.svg`}
                    />
                </div>
            </div>
            <div className={`sectionheader-searchcontainer`}>
                <input
                    className={`searchcontainer-searchinput`}
                    onChange={searchTools}
                    placeholder={`Search`}
                    type={`text`}
                />
            </div>
        </div>
    );
};
